// Copied from the Rust backend, tested in the same way
const RFC_5321_EMAIL_REGEX =
    /^([-_a-zA-Z0-9!#\$%&'\*\+/=\?\^`{\|}~]+(\.[-_a-zA-Z0-9!#\$%&'\*\+/=\?\^`{\|}~]+)*|"([ !#-\[\]-~]|\\[ -~])*")@[a-zA-Z0-9](([-a-zA-Z0-9])*[a-zA-Z0-9])?(\.[a-zA-Z0-9](([-a-zA-Z0-9])*[a-zA-Z0-9])?)*$/;

function isEmailValid(email: string | undefined) {
    if (!email) {
        return false;
    }
    if (email.length >= 255) {
        return false;
    }
    return RFC_5321_EMAIL_REGEX.test(email);
}

export { isEmailValid };
